import owd from 'owd/owd';

export default class PlayerInfo extends owd.Component {
	init() {
		this.$button = this.$element.find('[data-player-button]');
		this.$content = this.$element.find('[data-player-content]');
		this.isExtended = false;

		this.calcHeights();
		this.bind();

		// console.log(this.containerHeight, this.contentHeight);
	}

	calcHeights() {
		this.containerHeight = this.$element.outerHeight();
		this.contentHeight = this.$content.outerHeight();
	}

	open() {
		this.$element.outerHeight(this.containerHeight);
		this.$element.addClass('is-extended');
		this.isExtended = true;
	}

	close() {
		this.$element.outerHeight(this.contentHeight);
		this.$element.removeClass('is-extended');
		this.isExtended = false;
	}

	bind() {


		this.on('load ajaxload', this.dom.$window, () => {

			if (this.$content.length <= 3) {
				this.$button.hide();
			}

			this.close();
		})

		this.on('click', this.$button, () => {
			if (this.isExtended) {
				this.$button.text("Show All");
				this.close();
			} else {
				this.$button.text("Hide");
				this.open();
			}
		});
	}
}

owd.registerComponent('player-info', {
	component: PlayerInfo
});
